// eslint-disable-next-line deprecation/deprecation
import { ComponentFactoryResolver, ApplicationRef, Injector, Type, EmbeddedViewRef, ComponentRef, DOCUMENT } from '@angular/core';
import { UiDynamicDialogComponent } from './dynamic-dialog';
import { DynamicDialogRef, DynamicDialogConfig } from 'prime-ng-old/dynamicdialog';
import * as i0 from "@angular/core";
/**
 * remember to add DynamicDialogService to the providers list of COMPONENT!
 * It must not be provided on module level!
 *
 * Note: This looks like a 1:1 copy, but imported references have changed (local UiDynamicDialogComponent), requiring a copied implementation.
 */
export let DynamicDialogService = /*#__PURE__*/(() => {
  class DynamicDialogService {
    // eslint-disable-next-line deprecation/deprecation
    constructor(componentFactoryResolver, appRef, injector, document) {
      this.componentFactoryResolver = componentFactoryResolver;
      this.appRef = appRef;
      this.injector = injector;
      this.document = document;
      this.dialogComponentRefMap = new Map();
    }
    open(componentType, config) {
      if (typeof config.padded === 'undefined') config.padded = true;
      if (config.removeFocus) {
        this.document.activeElement?.blur();
      }
      const dialogRef = this.appendDialogComponentToBody(config);
      this.dialogComponentRefMap.get(dialogRef).instance.childComponentType = componentType;
      return dialogRef;
    }
    appendDialogComponentToBody(config) {
      const dialogRef = new DynamicDialogRef();
      const sub = dialogRef.onClose.subscribe(() => {
        this.dialogComponentRefMap.get(dialogRef).instance.close();
      });
      const destroySub = dialogRef.onDestroy.subscribe(() => {
        this.removeDialogComponentFromBody(dialogRef);
        destroySub.unsubscribe();
        sub.unsubscribe();
      });
      const localInjector = Injector.create({
        parent: this.injector,
        providers: [{
          provide: DynamicDialogConfig,
          useValue: config
        }, {
          provide: DynamicDialogRef,
          useValue: dialogRef
        }, ...(config.providers || [])]
      });
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(UiDynamicDialogComponent);
      const componentRef = componentFactory.create(localInjector);
      this.appRef.attachView(componentRef.hostView);
      const domElem = componentRef.hostView.rootNodes[0];
      this.document.body.appendChild(domElem);
      this.dialogComponentRefMap.set(dialogRef, componentRef);
      return dialogRef;
    }
    removeDialogComponentFromBody(dialogRef) {
      if (!dialogRef || !this.dialogComponentRefMap.has(dialogRef)) {
        return;
      }
      const dialogComponentRef = this.dialogComponentRefMap.get(dialogRef);
      this.appRef.detachView(dialogComponentRef.hostView);
      dialogComponentRef.destroy();
      this.dialogComponentRefMap.delete(dialogRef);
    }
    static {
      this.ɵfac = function DynamicDialogService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicDialogService)(i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(DOCUMENT));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: DynamicDialogService,
        factory: DynamicDialogService.ɵfac
      });
    }
  }
  return DynamicDialogService;
})();